import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { logger, setLogService } from '@equip/utils/logger';

setLogService('web');
const _gitCommit = (globalThis as { __GIT_COMMIT__?: string }).__GIT_COMMIT__ ?? 'unknown';
logger.info(`eQuip starting - commit: ${_gitCommit}`);

// Cleanup: remove localStorage keys orphaned by the sessionStorage migration
['column_preferences_v1', 'ui.front-window.preferences.v1', 'menu_prefs', 'ui.sidebar.collapsed'].forEach(
  (key) => window.localStorage.removeItem(key),
);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
